import { Fragment } from "react";
import { useMatches } from "remix";
import { useIsLoggedIn } from "~/utils/useIsLoggedIn";

export function Navigation() {
  const matches = useMatches();
  const isLoggedIn = useIsLoggedIn();
  const navLinks = matches
    // skip routes that don't have a breadcrumb
    .filter((match) => match.handle && match.handle.navLinks);

  return (
    <>
      {navLinks.length > 0 && (
        <div className="main-layout-centered border-slate-200 border-b bg-primary-600 sticky top-0 z-10">
          <nav className="flex flex-row">
            {navLinks.map((match) => (
              <Fragment key={match.id}>
                {match.handle.navLinks(match, isLoggedIn)}
              </Fragment>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
